import type { TopicsIdsModel, TopicsIdsDataModel } from '@/types';

export const defaultTopicsIds: TopicsIdsModel = {
  topicsPage: {
    all: { loadMoreUrl: null, ids: [] } as TopicsIdsDataModel,
    recommended: { loadMoreUrl: null, ids: [] } as TopicsIdsDataModel,
    following: { loadMoreUrl: null, ids: [] } as TopicsIdsDataModel,
    search: { loadMoreUrl: null, ids: [] } as TopicsIdsDataModel,
  },
  searchPage: { loadMoreUrl: null, ids: [] } as TopicsIdsDataModel,
};
